export function trainerFeedback(trainerSlug: string, itemType: string, correct: boolean | null): string {
  if (correct == null) {
    return trainerSlug === "english-sounds"
      ? "Ты сравнил свою попытку с эталоном."
      : "Шаг выполнен.";
  }
  if (trainerSlug === "word-in-frame") {
    if (correct) {
      if (itemType === "choose_picture") return "Да: берём в кадр.";
      if (itemType === "choose_word") return "Верно: это нужное слово.";
      return "Кадр совпал.";
    }
    if (itemType === "choose_picture") return "Это другой предмет. Позже будет новый кадр с этим словом.";
    if (itemType === "choose_word") return "На картинке другое слово. Попробуем с новым кадром.";
    return "Сейчас смысл другой. Позже вернёмся к этой реплике.";
  }
  if (trainerSlug === "phrase-director") {
    if (correct) {
      if (itemType === "BUILD") return "Реплика собрана. Снимаем кадр!";
      if (itemType === "LISTEN_SCENE") return "Ты услышал, что происходит в кадре.";
      return "Кадр готов.";
    }
    if (itemType === "BUILD") return "Кто в кадре? Поставь героя первым.";
    if (itemType === "LISTEN_SCENE") return "Послушай только героя, действие или место ещё раз.";
    if (itemType === "CONNECT") return "and добавляет похожее; but показывает контраст.";
    return "Проверь героя, действие или место и собери кадр снова.";
  }
  if (correct) {
    if (itemType === "costumes") return "Ты связал звук с буквами.";
    if (itemType === "position") return "Ты нашёл звук в слове.";
    if (itemType === "ipa") return "Ты узнал знак звука.";
    return "Ты услышал нужный звук.";
  }
  if (itemType === "costumes") return "Разберём слово по кусочкам. Смотри только костюмы из этих слов.";
  if (itemType === "position") return "Мы ищем то, что слышим, а не первую написанную букву.";
  if (itemType === "ipa") return "Послушай ещё раз и найди тот же знак.";
  return "Послушай ещё раз. Попробуем с другим примером.";
}
